import React from 'react'
import styled from 'react-emotion'
import { Link } from 'react-router-dom'
import { color } from '../../style'
import { StyledFormElement } from './FormElement'

const ButtonComponent = React.forwardRef(
  ({ className, Component, ...props }, ref) => {
    if (!Component) {
      if (props.to) Component = Link
      else if (props.href) Component = 'a'
    }
    return (
      <StyledFormElement
        {...props}
        Component={Component}
        className={className}
        innerRef={ref}
      />
    )
  }
)

export const Button = styled(ButtonComponent)(
  ({ inset, primary, disabled, active, danger }) => {
    const style = {
      label: 'Button',
      color: (primary || danger) && 'white',
      fontWeight: 500,
      cursor: disabled ? 'not-allowed' : 'pointer',

      height: inset && 20,
      minWidth: inset && 20,
      // justifyContent: 'center',
      padding: inset && `0 5px`,
      borderRadius: inset && 2,

      zIndex: primary && 1 // used in switcher to make sure border of adjcent button doesn't overlap
    }

    if (active) style.background = color.hover
    else if (primary) {
      style.background = color.black
      style.borderColor = color.black
    } else if (danger) {
      style.background = color.red
      style.borderColor = color.redLine
    }

    if (!disabled) {
      if (primary)
        style['&:hover'] = {
          backgroundColor: 'rgb(51, 51, 51)'
        }
      else if (danger)
        style['&:hover'] = {
          backgroundColor: color.redLine
        }
      else
        style['&:hover'] = {
          color: color.black,
          background: color.hover
        }
    }

    return style
  }
)

export const StyledButton = Button
export default Button
